import { Schema } from '@core/data/dto/schema';

export const DeliveryIntegrationSchema = {
    id: Schema.String,
    provider: Schema.String,
    provider_name: Schema.String,
    short_description: Schema.String,
    description: Schema.String,
    logo_small: Schema.String,
    keywords: Schema.Auto,
    install_type: Schema.Auto,
    status: Schema.Auto,
    customer_id: Schema.String,
    created_at: Schema.Moment
};
